require('./brokerHirePensionPlan.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const moment = require('moment');
const Immutable = require('immutable');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
const BrokerHirePensionPlanStep1 = require('./brokerHirePensionPlanStep1/brokerHirePensionPlanStep1');
const BrokerHirePensionPlanStep2 = require('./brokerHirePensionPlanStep2/brokerHirePensionPlanStep2');
const BrokerHirePensionPlanDetails = require('./brokerHirePensionPlanDetails/brokerHirePensionPlanDetails');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @ helpers
const { getLanguage, formatText } = require('core/i18n').i18n;
// @ constants
const { FIRST_STEP,
     DATE_FORMAT_API_DAY_MONTH_YEAR,
     DATE_FORMAT_API_MONTH_DAY_YEAR } = require('constants/index');

class BrokerHirePensionPlan extends React.Component {

    buildAccountsIndexes () {
         const { immAccounts, immHirePensionPlan } = this.props;
         const accountIndexes = immAccounts.get('byOrder');
         return immHirePensionPlan
            .getIn(['steps', 0, 'availableAccounts'])
            .filter(iban => accountIndexes.has(iban))
            .toJS();
    }

    buildWizard() {
        const {
            immAccounts,
            immHirePensionPlan,
            immPensionPlan,
            onAccountChange,
            onAnnualIncrementChange,
            onAnnualIncrementPercentageChange,
            onCancel,
            onDateChange,
            onFinish,
            onInitialContributionChange,
            onPeriodicityAmountChange,
            onPeriodicityChange,
            setVisibleStep,
            setWillCancel,
            validateStep,
            onToggleDisclaimer,
            setContributionAnswer,
            immProfile,
            onIntervenersChange,
            setDocumentsRead,
            blockedAccountsIds,
            immBrokerProductAdvancedSearch,
        } = this.props;

        const annualIncrement = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'annualIncrement']);
        const annualIncrementPercentage = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'annualIncrementPercentage']);
        const availableAccounts = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'availableAccounts']).toJS();
        const immAccountsMap = immAccounts.get('byId');
        const immErrorFlags = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'errorFlags']);
        const immFinalButton = 'broker-hireInvestmentSubmit';
        const immInterveners = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'interveners']);
        const immSteps = immHirePensionPlan.get('steps');
        const initialContribution = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'initialContribution']);
        const minimumAdditionalPurchase = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'periodicityAmountMinimum']);
        const contributionMinimumAmountCurrency = immPensionPlan.getIn(['pensionPlan', 'contributionMinimumAmountCurrency']);
        const minimumPurchase = Immutable.fromJS({
            amount: immPensionPlan.getIn(['pensionPlan', 'hireMinimumAmount']),
            currency: immPensionPlan.getIn(['pensionPlan', 'hireMinimumAmountCurrency'])
        });
        const pensionPlanName = immPensionPlan.getIn(['pensionPlan', 'name']);
        const pensionPlanProvider = immPensionPlan.getIn(['pensionPlan', 'provider']);
        const pensionPlanVocation = immPensionPlan.getIn(['pensionPlan', 'vocation']);
        const periodicContributionAmount = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'periodicityAmount']);
        const periodicContributionDate = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'periodicityDate']);
        const periodicContributionPeriodicity = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'periodicity']);
        const contributionQuestion = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'contributionQuestion']);
        const isPercentageInputAvailable = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'isPercentageInputAvailable']);
        const isPeriodicContributionAvailable = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'periodicContribution']);
        const selectedAccount = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'accountId']);
        const immAccount = immAccountsMap.get(selectedAccount);
        const accountNumber = immAccount ? immAccount.getIn(['ibanComplex', 'codbban']) : '';
        const isFetchingInterveners = immHirePensionPlan.get('isFetchingInterveners');
        const isFetchedIntervenersSuccess = immHirePensionPlan.get('isFetchedIntervenersSuccess');
        const selectedIntervener = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'selectedIntervener']);
        const selectedIntervenerLabel = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'selectedIntervenerLabel']);
        const participantName = immInterveners.getIn([selectedIntervener.toString(), 'name'], '');
        const contractNumber = immHirePensionPlan.get('planContractNumber');
        const productNumber = immHirePensionPlan.get('planProductNumber');
        const stepsAmount = immSteps.size;
        const visibleStep = immHirePensionPlan.get('visibleStep');
        const minDate = immHirePensionPlan.get('minDate');
        const wizardClass = 'broker-hire-pension-plan__wizard';
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: onFinish,
            cancel: onCancel
        };
        const headerMenuData = {
            title: formatText('brokerHirePlans-title'),
            linksData: [],
        };

        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={immSteps}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                >
                    <BrokerHirePensionPlanStep1
                        annualIncrement={annualIncrement}
                        annualIncrementPercentage={annualIncrementPercentage}
                        availableAccounts={availableAccounts}
                        immAccounts={immAccountsMap}
                        immErrorFlags={immErrorFlags}
                        immInterveners={immInterveners}
                        initialContribution={initialContribution}
                        minimumPurchase={minimumPurchase}
                        minimumAdditionalPurchase={minimumAdditionalPurchase}
                        onAccountChange={onAccountChange}
                        onAnnualIncrementChange={onAnnualIncrementChange}
                        onAnnualIncrementPercentageChange={onAnnualIncrementPercentageChange}
                        onDateChange={onDateChange}
                        onInitialContributionChange={onInitialContributionChange}
                        onPeriodicityAmountChange={onPeriodicityAmountChange}
                        onPeriodicityChange={onPeriodicityChange}
                        pensionPlanProvider={pensionPlanProvider}
                        periodicContributionAmount={periodicContributionAmount}
                        periodicContributionDate={periodicContributionDate}
                        periodicContributionPeriodicity={periodicContributionPeriodicity}
                        selectedAccount={selectedAccount}
                        immProfile={immProfile}
                        contributionQuestion={contributionQuestion}
                        setContributionAnswer={setContributionAnswer}
                        isPercentageInputAvailable={isPercentageInputAvailable}
                        contributionMinimumAmountCurrency={contributionMinimumAmountCurrency}
                        selectedIntervenerLabel={selectedIntervenerLabel}
                        onIntervenersChange={onIntervenersChange}
                        isFetchingInterveners={isFetchingInterveners}
                        isFetchedIntervenersSuccess={isFetchedIntervenersSuccess}
                        minDate={minDate}
                        blockedAccountsIds={blockedAccountsIds}
                        isBlockedAccountsLoading={isBlockedAccountsLoading}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    <BrokerHirePensionPlanStep2
                        immPensionPlan={immPensionPlan}
                        immHirePensionPlan={immHirePensionPlan}
                        immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                        onToggleDisclaimer={onToggleDisclaimer}
                        immAccount={immAccount}
                        accountNumber={accountNumber}
                        annualIncrement={annualIncrement}
                        annualIncrementPercentage={annualIncrementPercentage}
                        initialContribution={initialContribution}
                        participant={participantName}
                        pensionPlanGestor={pensionPlanProvider}
                        pensionPlanName={pensionPlanName}
                        pensionPlanVocation={pensionPlanVocation}
                        periodicity={periodicContributionPeriodicity}
                        periodicityAmount={periodicContributionAmount}
                        periodicityDate={periodicContributionDate}
                        productNumber={productNumber}
                        contractNumber={contractNumber}
                        isPeriodicContributionAvailable={isPeriodicContributionAvailable}
                        setDocumentsRead={setDocumentsRead}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    render () {
        let content = this.buildWizard();
        const { immHirePensionPlan, immPensionPlan, immAccounts } = this.props
        if (immHirePensionPlan.get('submitSuccessful')) {
            const successTitle = formatText('brokerHirePlans-successTitle');
            const goBackButton = {
                label: formatText('brokerHirePlans-goBack'),
                url: '/myprofile/broker'
            }

            const selectedAccount = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'accountId']);
            const accountNumber = immAccounts.getIn(['byId', selectedAccount, 'ibanComplex', 'codbban']);
            const annualIncrement = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'annualIncrement']);
            const annualIncrementPercentage = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'annualIncrementPercentage']);
            const initialContribution = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'initialContribution']);
            const pensionPlanName = immPensionPlan.getIn(['pensionPlan', 'name']);
            const pensionPlanProvider = immPensionPlan.getIn(['pensionPlan', 'provider']);
            const pensionPlanVocation = immPensionPlan.getIn(['pensionPlan', 'vocation']);
            const periodicContributionAmount = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'periodicityAmount']);
            const periodicContributionDate = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'periodicityDate']);
            const periodicContributionPeriodicity = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'periodicity']);
            const immInterveners = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'interveners']);
            const selectedIntervener = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'selectedIntervener']).toString();
            const participantName = immInterveners.getIn([selectedIntervener, 'name'], '');
            const orderDate = getLanguage() == 'en' ? moment().format(DATE_FORMAT_API_MONTH_DAY_YEAR) : moment().format(DATE_FORMAT_API_DAY_MONTH_YEAR);
            const isPeriodicContributionAvailable = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'periodicContribution']);
            const wizardClass = 'broker-hire-pension-plan__wizard broker-hire-pension-plan';

            content = (
                <WizardSuccess
                    customClassName={wizardClass}
                    successMessage={successTitle}
                    mainButton={goBackButton}
                >
                    <BrokerHirePensionPlanDetails
                        accountNumber={accountNumber}
                        annualIncrement={annualIncrement}
                        annualIncrementPercentage={annualIncrementPercentage}
                        initialContribution={initialContribution}
                        orderDate={orderDate}
                        participant={participantName}
                        pensionPlanGestor={pensionPlanProvider}
                        pensionPlanName={pensionPlanName}
                        pensionPlanVocation={pensionPlanVocation}
                        periodicity={periodicContributionPeriodicity}
                        periodicityAmount={periodicContributionAmount}
                        periodicityDate={periodicContributionDate}
                        isPeriodicContributionAvailable={isPeriodicContributionAvailable}
                    />
                </WizardSuccess>
            );
        }

        return content;
    }
}

BrokerHirePensionPlan.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immHirePensionPlan: PropTypes.object.isRequired,
    immPensionPlan: PropTypes.object.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    onAnnualIncrementChange: PropTypes.func.isRequired,
    onAnnualIncrementPercentageChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDateChange: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onInitialContributionChange: PropTypes.func.isRequired,
    onPeriodicityAmountChange: PropTypes.func.isRequired,
    onPeriodicityChange: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onToggleDisclaimer: PropTypes.func.isRequired,
    setContributionAnswer: PropTypes.func.isRequired,
    immProfile: PropTypes.object,
    onIntervenersChange: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    blockedAccountsIds: PropTypes.array,
    immBrokerProductAdvancedSearch: PropTypes.object,
};

module.exports = BrokerHirePensionPlan;
